import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
export default function NetworkDropdown() {
  const [age, setAge] = React.useState("20");
  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Network</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
        //   value={network}
          value={age}
          label="Network"
          onChange={handleChange}
        >
          <MenuItem value={10} disabled>Mainnet</MenuItem>
          <MenuItem value={20}>Testnet</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
